import { AssessmentSimple } from 'domain/entities/AssessmentEntity';
import { AppProps } from 'presentation/App';
import { PageTitle } from 'presentation/components/PageTitle';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { RangeData } from '../CU-056-02/Models/Range';
import { FormCostAccounting } from './components/FormCostAccounting';
import { ReferencePriceComponent } from './components/ReferencePriceComponent';

const CU05603Page = (props: AppProps) => {
    const [range, setRange] = useState<RangeData>();
    const [assessmentData, setAssessmentData] = useState<AssessmentSimple>();
    const [stationSelect, setStationSelect] = useState<any>();
    const location = useLocation();
    useEffect(() => {
        setAssessmentData(location.state.assessmentData);
        setRange(location.state.range);
        setStationSelect(location.state.stationSelect);
    }, []);

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
            }}
            className="CU-056-03-container"
        >
            <PageTitle title="かんたん査定" />
            <div className="center-inside w-full h-full">
                <div className="center-item h-full w-full w-full md:w-2/3 2xl:w-1/2">
                    {range && <ReferencePriceComponent {...range} />}
                    {assessmentData && (
                        <FormCostAccounting
                            setRange={setRange}
                            stationSelect={stationSelect}
                            assessmentSimple={assessmentData}
                            {...props}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};
export default CU05603Page;
